import { Add, Delete, Edit } from "@mui/icons-material"
import { Box, Checkbox, Divider, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import Spinner from "./Spinner"
import React from "react"


const CustomList = ({
    data, isLoading,
    canEdit = true,
    onAdd, onEdit, onDelete, onBulkDelete,
    current, onSelect,
    primaryValueGetter, secondaryValueGetter,
    entityComparer = (current, entity) => current?.id === entity?.id,
    additionalActions = [],
    freeActions = [],
    width, height,
    enableChecking,
    checked,
    setChecked,
}) => {

    const actionsCount = React.useMemo(() => {
        let res = additionalActions?.length ?? 0
        if (onEdit) res += 1
        if (onDelete) res += 1
        return res
    }, [additionalActions, onEdit, onDelete])

    return <List disablePadding sx={{ height, width }}>
        <ListItem
            disablePadding
            sx={{ pl: 2 }}
            secondaryAction={<>
                {freeActions.map((action, index) => <IconButton key={index} size="small" onClick={action.onClick}>
                    {<action.icon color="primary" />}
                </IconButton>)}
                {(canEdit && onAdd) && <IconButton size="small" onClick={onAdd}>
                    <Add color="primary" />
                </IconButton>}
                {(canEdit && enableChecking && checked?.length > 0) && <IconButton size="small" onClick={() => onBulkDelete()}>
                    <Delete color="error" />
                </IconButton>}
            </>}
        >
            {enableChecking && <ListItemIcon>
                <Checkbox
                    size="small"
                    checked={checked.length !== 0 && checked.every(x => data.find(d => x.id === d.id))}
                    tabIndex={-1}
                    disableRipple
                    onClick={(event) => { setChecked(event.target.checked ? data : []) }}
                />
            </ListItemIcon>}
            <ListItemText primaryTypographyProps={{ variant: "h6" }} primary="Занятия" />
        </ListItem>

        <Divider />

        {isLoading ? (
            <Spinner height={height} />
        ) : (
            <Box sx={{ height: "calc(100% - 41px)", overflowY: "auto" }}>
                {data.map((item, index) => <ListItem
                    key={index}
                    disablePadding
                    secondaryAction={canEdit && <>
                        {additionalActions.map((action, index) => <IconButton
                            key={index}
                            size="small"
                            onClick={() => action.onClick(item)}
                        >
                            {<action.icon color="primary" fontSize="small" />}
                        </IconButton>)}
                        {onEdit && <IconButton size="small" onClick={() => onEdit(item)}>
                            <Edit color="primary" fontSize="small" />
                        </IconButton>}
                        {onDelete && <IconButton size="small" onClick={() => onDelete(item)}>
                            <Delete color="error" fontSize="small" />
                        </IconButton>}
                    </>}
                >
                    <ListItemButton selected={entityComparer(current, item)}>
                        {enableChecking && <ListItemIcon>
                            <Checkbox
                                size="small"
                                checked={!!checked.find(x => x.id === item.id)}
                                tabIndex={-1}
                                disableRipple
                                onClick={(event) => {
                                    if (event.target.checked) {
                                        setChecked([...checked, item])
                                    } else {
                                        setChecked(checked.filter(x => x.id !== item.id))
                                    }
                                }}
                            />
                        </ListItemIcon>}
                        <ListItemText
                            onClick={() => onSelect(item)}
                            primaryTypographyProps={{ mr: actionsCount * 3, fontSize: 14 }}
                            secondaryTypographyProps={{ mr: actionsCount * 3, fontSize: 12 }}
                            primary={primaryValueGetter(item)}
                            secondary={secondaryValueGetter(item)}
                        />
                    </ListItemButton>
                </ListItem>
                )}
            </Box>)}
    </List>
}

export default CustomList